/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react'; 
import { useTranslation } from 'react-i18next'; 
import PageContent from '../../../layouts/PageContent'; 
import { Toolbar } from 'primereact/toolbar'; 
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Row, Col , 
    ListGroupItem,
    ListGroup,
    Progress,} from 'reactstrap';  
import HomeMenuCard from '../../../components/Cards/HomeMenuCard/HomeMenuCard.jsx';
import PeerToPeerImg from '../../../assets/img/PeerToPeer.png';
import ListItem from '../../../components/ListGroup/ListItem.jsx'
import { useHistory, Link } from "react-router-dom";

const PeerToPeerRecognition = (props) => { 
  /* ################## useState area start ################## */
  const { t } = useTranslation(['hr', 'common']);

  const peerToPeerLink = useRef(null);

  const onPeerToPeerClick = () => { 
    peerToPeerLink.current.click();
  }

    return (
      <> 
        <HomeMenuCard title={t('hr:PeerToPeerRecognition')} className='HomeMenuCard' imageSrc={PeerToPeerImg} color="#e63542">
          <Col lg={12} md={12} sm={12} xs={12}>   
            <Row>
              <Col>
                <div><b>Who can recognize?</b></div> 
                <div><span>Everyone! All employees are encouraged to participate – whether you&#39;re in the office, on the floor, or out in the field. If you see something worth celebrating, take a moment to recognize your peer. Recognition is open across departments, teams, and roles – because great work happens everywhere.</span></div>
                <div className='mt-2'><b>To begin your nomination please click the link below.</b></div>
              </Col>
            </Row>
            <Row className='mt-2'>
              <Col>
                <ListItem title={t('hr:PeerToPeerRecognition')} color="#d0323a" onClick={onPeerToPeerClick} />
              </Col>
            </Row>
          </Col>
        </HomeMenuCard>
        <Link ref={peerToPeerLink} to={{ pathname: "https://sirius.mcswusa.com/r/Survey/9BBB4605B166424" }} target="_blank" />
      </>  
        ); 
};

export default PeerToPeerRecognition;
